import { ConsentCategory } from './types';

export function hasUserConsentedToPersonalizedAds(doc: Document): boolean {
    let cookieValue;
    let categoryValue;
    const TAILORED_ADVERTISING_ID = 3;
    try {
        const consentCookie = doc.cookie.match(
            '(^|[^;]+)\\s*cookie_consents\\s*=\\s*([^;]+)'
        );
        cookieValue = consentCookie?.pop() || '';
        categoryValue = JSON.parse(
            cookieValue
        ).content.consents[0].categories.find(
            (category: ConsentCategory) =>
                category.id === TAILORED_ADVERTISING_ID
        ).consentGiven;
    } catch {
        return false;
    }

    if (
        typeof cookieValue === 'undefined' ||
        typeof categoryValue === 'undefined' ||
        typeof categoryValue !== 'boolean'
    ) {
        return false;
    }

    return categoryValue;
}
